<mat-menu
  #menu
  class="main-menu-panel">
  @if (items().length) {
    @for (item of items(); track item.label) {
      @if (item.subItems && item.subItems.length) {
        @let isAllItemNeedsUpgrade = isAllSubItemsRequireUpgrade | wrapFn: item.subItems;
        <button
          mat-menu-item
          [matMenuTriggerFor]="isAllItemNeedsUpgrade ? null : submenu.menu()"
          [class.disabled]="isAllItemNeedsUpgrade"
          (click)="isAllItemNeedsUpgrade ? handleClick(item.subItems[0], $event) : null"
          class="link">
          <div class="flex align-center">
            <span class="menu-label">{{ item.name }}</span>
            @if (isAllItemNeedsUpgrade) {
              <ume-lock-icon class="m-l-quoter"></ume-lock-icon>
            }
          </div>
        </button>
        <ume-main-nav-menu-panel
          #submenu
          [items]="item.subItems"></ume-main-nav-menu-panel>
      } @else {
        <!-- case for external links -->
        @if (item.target && !item.requestUrl) {
          <a
            mat-menu-item
            routerLinkActive="link_active"
            [target]="item.target"
            [href]="item.link"
            [class.disabled]="item.disabled || item.payment"
            (click)="handleClick(item, $event)">
            <div class="flex align-center">
              <span class="menu-label">
                {{ item.name }}
              </span>
              @if (isUpgradeRequired | wrapFn: item) {
                <ume-lock-icon class="m-l-quoter"></ume-lock-icon>
              }
            </div>
          </a>
        }
        @if (!item.target && !item.requestUrl) {
          <a
            mat-menu-item
            routerLinkActive="link_active"
            [routerLink]="item.link | companyTypeBasedRoute"
            [class.disabled]="item.disabled || item.payment"
            (click)="handleClick(item, $event)">
            <div class="flex align-center">
              <span class="menu-label">
                {{ item.name }}
              </span>
              @if (isUpgradeRequired | wrapFn: item) {
                <ume-lock-icon class="m-l-quoter"></ume-lock-icon>
              }
            </div>
          </a>
        }
        @if (item.requestUrl) {
          <button
            mat-menu-item
            class="link"
            [class.disabled]="item.disabled || item.payment"
            (click)="handleClick(item, $event)">
            <div class="flex align-center">
              <span class="menu-label">
                {{ item.name }}
              </span>
              @if (isUpgradeRequired | wrapFn: item) {
                <ume-lock-icon class="m-l-quoter"></ume-lock-icon>
              }
            </div>
          </button>
        }
      }
    }
  }
</mat-menu>
